<template>
    <div class="products-import">
        <div v-if="step == 1">
            <span
                v-if="typeOfImport === 'generalImport'"
                class="heading"
                :class="mode"
            >
                {{ $t('products.import.heading', { columns: isAllegra ? 2 : 3 }) }}
            </span>
            <span
                v-else
                class="heading"
                :class="mode"
            >
                {{ $t('products.import.heading_update') }}
            </span>
            
            <v-form ref="importForm">
                <v-file-input
                    v-model="productsFile"
                    class="mt-5"
                    accept=".xlsx, .xls, .csv"
                    :label="$t('products.import.file')"
                    :rules="[CodForm.rule('required')]"
                    clearable
                    outlined
                    prepend-inner-icon="fal fa-paperclip"
                    prepend-icon=""
                    clear-icon="fal fa-times"
                />
            </v-form>

            <v-fade-transition>
                <div v-if="failedProducts && failedProducts.length">
                    <div class="mb-3 error--text text-body-2">
                        {{ $t('products.import.fail') }}
                    </div>
                    <ul
                        v-for="(product, index) in failedProducts"
                        :key="index"
                        class="error--text text-body-2"
                    >
                        <li>{{ `${$tc('general.row', 1)} #${product.row}: ` + $t(`products.import.${product.error[0]}`) }}</li>
                    </ul>
                </div>
            </v-fade-transition>
        </div>

        <v-fade-transition>
            <div v-if="step == 2">

                <div class="error--text mt-1 mb-5 text-body-2">
                    {{ $t('products.import.assign_categories') }}
                </div>

                <v-form ref="categoriesForm">
                    <v-row
                        v-for="(category, index) in categories"
                        :key="index"
                        class="mb-3"
                        no-gutters
                    >
                        <v-col
                            cols="4"
                            class="d-flex align-center text-subtitle-2"
                        >
                            {{ category.name }}:
                        </v-col>
                        <v-col cols="8">
                            <v-select
                                v-model="category.type"
                                :items="appConfig.product.types"
                                :rules="[CodForm.rule('required')]"
                                class="py-0"
                                dense
                                outlined
                                hide-details
                            >
                                <template
                                    slot="selection"
                                    slot-scope="data"
                                >
                                    <label>{{ $t(`general.${data.item}`) }}</label>
                                </template>
                                <template
                                    slot="item"
                                    slot-scope="data"
                                >
                                    <label>{{ $t(`general.${data.item}`) }}</label>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
        </v-fade-transition>
    </div>
</template>

<script>
import ApiService from '@/services/ApiService';

export default {
    props: {
        mode: {
            type: String,
            default: 'admin',
        },
        typeOfImport: {
            type: String,
            required: true 
        }
    },

    data() {
        return {
            step: 1,
            productsFile: null,
            categories: [],
            failedProducts: [],
        };
    },
    watch: {
        productsFile(val) {
            if(val) {
                this.categories = [];
                this.failedProducts = [];
            }
        }
    },

    methods: {
        /*
        * Save products imported from a local file
        */
        async importFile() {
            if (this.step === 2) {
                if (!this.$refs.categoriesForm.validate()) return false

                try {
                    const apiUrl = this.mode === 'getstarted' ? `/${this.mode}/categories/import` 
                                : `/${this.mode}/categories-update/import`
                    const response = await ApiService.post(apiUrl, { categories: this.categories })
                    this.reset();
                    this.$emit('import', response.data)
                } catch(error) {
                    console.log(error.message)
                    this.$emit('error')
                    return false;
                }
                return true
            }

            if (!this.$refs.importForm.validate()) return false

            let formData = new FormData();
            formData.append('products', this.productsFile);
            
            let requireCategory = 1
            let requireType = 1
            
            if(this.isAllegra) {
                requireCategory = 0
                requireType = 0
            }

            formData.append('require_category', requireCategory);
            formData.append('require_type', requireType);

            try {
                const apiUrl = this.typeOfImport === 'generalImport' ? `/${this.mode}/products/import` 
                                                    : `/${this.mode}/products-update/import`;
    
                const response = await ApiService.post(apiUrl, formData, {
                    transformRequest: (data, headers) => {
                        headers.common['Content-Type'] = 'multipart/form-data';
                        return data;
                    }
                })

                this.reset();
                if (response.data.newCategories && response.data.newCategories.length > 0 &&
                        response.data.failedProducts.length === 0) {
                    this.categories = response.data.newCategories.map(name => ({ name: name, type: null }));
                    this.step++;
                } else if (response.data.failedProducts && response.data.failedProducts.length) {
                    this.failedProducts = response.data.failedProducts;
                } else {
                    this.$emit('import', response.data)
                }

            } catch(error) {
                console.log(error.message)
                this.$emit('error')
                return false;
            }

            return true
        },

        /*
        * Close import form and clear contents
        */
        reset() {
            this.step = 1;
            this.productsFile = null;
            this.categories = [];
            this.failedProducts = [];

            if(this.$refs.importForm) {
                this.$refs.importForm.resetValidation()
            }
            
            if(this.$refs.categoriesForm) {
                this.$refs.categoriesForm.resetValidation()
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.products-import {
    .heading {
        margin-bottom: 30px;
        font-size: 14px;

        &.getstarted {
            color: #8f9095;
        }
    }
}
</style>
